import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { toCurrency } from 'services/Pricer';
import features from '../lib/common/features';

const Price = ({ priceData, showDescription, isStacked }) => {
  let price = priceData.price_with_fee || priceData.price;

  return (
    <span
      className={classnames('syos-price', {
        'syos-price--stacked': isStacked,
        'syos-price--has-description': showDescription
      })}
    >
      {showDescription && (
        <span className="syos-price__description">
          {priceData.price_type_desc}
        </span>
      )}
      {features.isEnabled('priceFees') ? (
        <div className="syos-price__value">
          <span className="syos-price__total">{toCurrency(price)}</span>
          {priceData.fee_amount ? (
            <div
              className="syos-price__breakdown"
              dangerouslySetInnerHTML={{
                __html: features
                  .getOption('priceFees', 'label')
                  .replace('{{ fees }}', toCurrency(priceData.fee_amount))
                  .replace('{{ price }}', toCurrency(priceData.price))
              }}
            />
          ) : null}
        </div>
      ) : (
        <span className="syos-price__value">{toCurrency(priceData.price)}</span>
      )}
    </span>
  );
};
Price.propTypes = {
  priceData: PropTypes.shape({
    price: PropTypes.string,
    price_type_desc: PropTypes.string
  }),
  showDescription: PropTypes.bool,
  isStacked: PropTypes.bool
};
Price.defaultProps = {
  showDescription: true
};

export default Price;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/Price.js